import {CssVariables, MediaQuery} from '@constants/theme';
import MuiBox from '@new-components/atoms/MuiBox';

interface FeaturedCommunityMdSlideWrapperProps {
  children: React.ReactNode;
}

const FeaturedCommunityMdSlideWrapper: React.FC<
  FeaturedCommunityMdSlideWrapperProps
> = (props) => {
  return (
    <MuiBox
      sx={{
        display: 'none',
        [MediaQuery.desktop]: {
          display: 'flex',
          gap: 3,
          px: `var(${CssVariables.mobilePadding})`,
        },
      }}>
      {props.children}
    </MuiBox>
  );
};

export default FeaturedCommunityMdSlideWrapper;
